var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuToggle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 128",
    style: {
      enableBackground: "new 0 0 96 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.menu-toggle-st0{opacity:0;}\r\n\t.fill-brand{fill:#00ffee;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "menu-toggle-st0",
    width: 96,
    height: 128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8,82.7c-0.3,0-0.5-0.1-0.7-0.3L37.7,64l18.4-18.4c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-17,17l17,17c0.4,0.4,0.4,1,0,1.4 C57.4,82.6,57.1,82.7,56.8,82.7z",
    className: "fill-brand"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuToggle);
export default __webpack_public_path__ + "static/media/menu-toggle.4730d3429bec474ea8d8050f28bc4fc1.svg";
export { ForwardRef as ReactComponent };